import { observer } from 'mobx-react'
import { FlowRunner } from "../../components/FlowRunner";
import { AdminVolunteerRegistrationFlowDefinition } from "../data/AdminVolunteerRegistrationFlowDefinition";
import { IDialogState } from "../../../../stores/models/DialogState";
import { IShift, Shift } from '../../../../stores/models/Shift';
import ThemedDialogWithSpinner from '../../../../components/Shared/Dialogs/ThemedDialogWithSpinner';
import { useMediaQuery, Theme } from '@material-ui/core';
import { useStandardStyles } from '../../../../shared/general/hooks/useStandardStyles';
import clsx from "clsx";

interface AdminVolunteerRegistrationFlowProps {
    dialogState: IDialogState;
    topLevelShift: Shift; // ITopLevelShift;
    registeredVolunteerIds: number[];
    offset?: number;
    onVolunteersRegistered?: (shift: IShift) => void;
}

const AdminVolunteerRegistrationFlow = observer((props: AdminVolunteerRegistrationFlowProps) => {

    const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    const baseClasses = useStandardStyles();

    /********* Render *********/

    return (
        <ThemedDialogWithSpinner
            DialogProps={{ fullScreen: smDown, PaperProps: { className: baseClasses.flexGrow }, fullWidth: true, maxWidth: 'lg' }}
            DialogContentProps={{ className: baseClasses.flex }}
            FormProps={{ className: clsx(baseClasses.flex, baseClasses.flexGrow, baseClasses.flexColumn, baseClasses.fullWidth) }}
            state={props.dialogState}
            title={props.dialogState.title}
            primaryButtonProps={props.dialogState.primaryButton}
            cancelText={props.dialogState.cancelText}
            leftButtonProps={props.dialogState.leftButton}
            hideCancelButton={props.dialogState.hideCancelButton}
        >
            <FlowRunner
                flow={AdminVolunteerRegistrationFlowDefinition}
                initialState={{
                    volunteerIds: [],
                    offsets: props.offset !== undefined ? [props.offset] : [],
                    onVolunteersRegistered: props.onVolunteersRegistered
                }}
                externalState={{
                    dialogState: props.dialogState,
                    topLevelShift: props.topLevelShift,
                    registeredVolunteerIds: props.registeredVolunteerIds,
                }}
            />
        </ThemedDialogWithSpinner>
    );
});

export default AdminVolunteerRegistrationFlow;